import { render, staticRenderFns } from "./HorizontalFormGroup.vue?vue&type=template&id=38dd5dc3"
import script from "./HorizontalFormGroup.vue?vue&type=script&lang=js"
export * from "./HorizontalFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports